/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getEnv } from '@config';

import { useReports } from '@hooks';
import Tag from 'components/Tag';

import { format } from 'date-fns';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { DotsMenu } from './DotsMenu';
import { REPORT_TYPE_LABELS, STATE_LABELS, TAG_TYPE } from './constants';
import { SkeletonLoader } from './List.SkeletonLoader';

const { publicPath } = getEnv();

const ListContainer = styled.div`
  display: none;

  ${({ theme }) => theme.newBreakpoint('new_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  > div {
    align-items: center;
  }

  > div:first-child {
    display: flex;
    padding-bottom: 8px;
    font-size: 14px;
    > div {
      padding: 0px;
    }
    div:first-child {
      flex-grow: 1;
    }
    div:nth-child(2) {
      color: #a2a7ba;
    }
  }

  > div:nth-child(2) {
    color: #a2a7ba;
  }

  > div:nth-child(3) {
    display: flex;
    padding-top: 4px;
    > div {
      padding: 0px;
    }
    div:first-child {
      flex-grow: 1;
    }
  }
`;

const NoReports = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 40vh;
  text-align: center;

  > img {
    width: 108px;
  }

  > div:first-of-type {
    padding-top: 5px;
    font-size: 18px;

    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      width: 240px;
    }
  }

  > div:last-child {
    color: #a2a7ba;
    padding-top: 8px;
    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      width: 300px;
    }
  }
`;

const PERIOD_LABELS = {
  1: 'reportsScreen.period.daily',
  7: 'reportsScreen.period.weekly',
  14: 'reportsScreen.period.biweekly',
  15: 'reportsScreen.period.biweekly',
};

const getPeriodLabel = (period) => {
  const [date1, date2] = period.split(' - ').map((stringDate) => moment(stringDate));
  const numberOfDays = date2.diff(date1, 'days');

  return PERIOD_LABELS[numberOfDays] ?? 'reportsScreen.period.monthly';
};

const period = ({ startDate, endDate }) =>
  `${format(new Date(startDate), 'dd/MM/yyyy')} - ${format(new Date(endDate), 'dd/MM/yyyy')}`;

export const List = ({ skeleton }) => {
  const { t } = useTranslation();
  const { reports: totalReports, reportsRangeToShow, reportsTypeToShow } = useReports();

  const { breakpoint } = useBreakpoints();

  const reports = reportsTypeToShow || totalReports;

  const currePageReportList = reports?.slice(reportsRangeToShow[0], reportsRangeToShow[1]) ?? [];

  return (
    <ListContainer>
      {skeleton ? (
        <SkeletonLoader />
      ) : reports?.length === 0 && breakpoint === 'xs' ? (
        <>
          <NoReports>
            <img
              src={`${publicPath}/assets/images/empty-folder.svg`}
              id="empty-reports"
              alt="Sin reportes"
            />
            <div>{t('reportsScreen.emptyState.title')}</div>
            <div>{t('reportsScreen.emptyState.description')}</div>
          </NoReports>
        </>
      ) : (
        <>
          {currePageReportList.map(
            ({
              created_at: date,
              start_date: startDate,
              end_date: endDate,
              type,
              report_id,
              state,
              link,
              _id,
            }) => (
              <Card key={report_id}>
                <div>
                  {/* <div>{report_id}</div> // TODO: v3, order list and number report */}
                  <div>{format(new Date(date), 'dd/MM/yyyy')}</div>
                  <div>
                    {[TAG_TYPE.SUCCESS, TAG_TYPE.ERROR].includes(STATE_LABELS[state].tag) && (
                      <DotsMenu link={link} id={_id} />
                    )}
                  </div>
                </div>
                <div>{t(REPORT_TYPE_LABELS[type])}</div>
                <div>
                  <div>{period({ startDate, endDate })}</div>
                  <Tag type={STATE_LABELS[state].tag}>{t(STATE_LABELS[state].key)}</Tag>
                </div>
              </Card>
            )
          )}
        </>
      )}
    </ListContainer>
  );
};
